<template>
  <section :id="title" :class="title">
    <h2>{{$props.title}}</h2>
    <div class="underline"></div>
    <slot>No section content available.</slot>
  </section>
</template>

<script>
export default {
  name: "Section",
  props: ["title"]
};
</script>